import { Option, CubismFramework } from './live2dcubismframework';
import { LAppPal } from '../../lapp/lapppal';
import { LAppSubdelegate } from '../../lapp/lappsubdelegate';
import * as LAppDefine from '../../lapp/lappdefine';
export class Live2DApp {
    constructor() {
        Object.defineProperty(this, "subdelegate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "animationFrameId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "pendingLipSyncValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
    }
    async initialize(canvas) {
        if (!CubismFramework.isStarted()) {
            const option = new Option();
            option.logFunction = LAppPal.printMessage;
            option.loggingLevel = LAppDefine.CubismLoggingLevel;
            CubismFramework.startUp(option);
        }
        if (!CubismFramework.isInitialized()) {
            CubismFramework.initialize();
        }
        LAppPal.updateTime();
        const subdelegate = new LAppSubdelegate();
        if (!subdelegate.initialize(canvas)) {
            throw new Error('Failed to initialize LAppSubdelegate');
        }
        this.subdelegate = subdelegate;
        subdelegate.getLive2DManager().addModel(0);
        try {
            await this.waitForModelReady();
        }
        catch (err) {
            if (this.subdelegate) {
                throw err;
            }
            return;
        }
        this.startLoop();
    }
    setLipSyncValue(value) {
        this.pendingLipSyncValue = Math.min(1, Math.max(0, value));
    }
    dispose() {
        this.pendingLipSyncValue = 0;
        if (this.animationFrameId != null) {
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = null;
        }
        if (this.subdelegate) {
            this.subdelegate.release();
            this.subdelegate = null;
        }
    }
    startLoop() {
        const tick = () => {
            if (!this.subdelegate)
                return;
            LAppPal.updateTime();
            const manager = this.subdelegate.getLive2DManager();
            const model = manager.getModel(0);
            if (model) {
                model.setExternalLipSyncValue(this.pendingLipSyncValue);
            }
            this.subdelegate.update();
            this.animationFrameId = requestAnimationFrame(tick);
        };
        this.animationFrameId = requestAnimationFrame(tick);
    }
    async waitForModelReady() {
        if (!this.subdelegate)
            return;
        const getManager = () => this.subdelegate?.getLive2DManager() ?? null;
        await new Promise((resolve, reject) => {
            const check = () => {
                const manager = getManager();
                if (!manager) {
                    reject(new Error('Live2D manager disposed before initialization'));
                    return;
                }
                const model = manager.getModel(0);
                if (model && model.isInitialized()) {
                    resolve();
                    return;
                }
                requestAnimationFrame(check);
            };
            check();
        });
    }
    startMotion(group, index, priority = LAppDefine.PriorityForce, onFinished) {
        const model = this.subdelegate?.getLive2DManager().getModel(0);
        if (!model)
            return;
        if (onFinished) {
            model.startMotion(group, index, priority, () => onFinished());
        }
        else {
            model.startMotion(group, index, priority);
        }
    }
    setExpression(name) {
        const model = this.subdelegate?.getLive2DManager().getModel(0);
        model?.setExpression(name);
    }
    stopAllMotions() {
        const model = this.subdelegate?.getLive2DManager().getModel(0);
        model?.stopAllMotions();
    }
    startIdle() {
        const model = this.subdelegate?.getLive2DManager().getModel(0);
        model?.startIdle();
    }
}
